export default "__VITE_ASSET__iiUWAoZF__"